export const EXTERNAL_LINKS = {
  GOB_CURP: 'https://www.gob.mx/curp/',
  CASANOVA_BIOMETRICS: 'http://biometrics.casanova-sara-ist.com/signatures',
};
